<template>
  <winners-highlights-modal
    v-if="isLazyLoaded"
    @hook:mounted="$_lazyLoadModal_onComponentMounted"
  />
</template>

<script>
import mixins from '@/utils/mixins'
import { MODAL } from '@/components/_modals/AModalWrapper/enums'

export default {
  name: 'WinnersHighlightsModalLazyLoad',
  mixins: [mixins.lazyLoadModal(MODAL.HIGHLIGHTS)],
  components: {
    WinnersHighlightsModal: () => import('./index')
  }
}
</script>

<style lang="scss" scoped></style>
